module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_023.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_023.png
// module id = 2370
// module chunks = 5